import { Directive, EmbeddedViewRef, Injector, Input, TemplateRef, ViewContainerRef, inject } from '@angular/core';

@Directive({
  selector: '[boschUiCellDef]',
  standalone: false,
})
export class BoschUiCellDefDirective<DataType> extends TemplateRef<DataType> {
  public readonly templateRef = inject(TemplateRef<DataType>);
  public readonly viewContainer = inject(ViewContainerRef);

  @Input() set boschUiCellDef(context: DataType) {
    this.viewContainer.clear();
    this.viewContainer.createEmbeddedView(this.templateRef, context);
  }
  elementRef = this.templateRef.elementRef;

  override createEmbeddedView(context: DataType, injector?: Injector): EmbeddedViewRef<DataType> {
    return this.templateRef.createEmbeddedView(context, injector);
  }
}
